import { withAuthenticationRequired } from "@auth0/auth0-react"
import { Loading } from "@bancacfplus/Loading"
import React from "react"

export const AuthenticationGuard = ({ component }: { component: React.ComponentType<object> }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Loading />
  })

  return <Component />
}
